// eslint-disable-next-line no-unused-vars
import { CUSTOM_FIELDS_TYPES, actionType, IBaseStateProps } from './types';

const initialState: IBaseStateProps = {
  loading: false,
  error: false,
  data: {}
};

export const customFieldsFormReducer = (state = initialState, action: actionType) => {
  switch (action.type) {
    case CUSTOM_FIELDS_TYPES.FETCH:
      return {
        ...state,
        loading: true,
        error: false
      };
    case CUSTOM_FIELDS_TYPES.SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: { ...state.data, typesList: action.payload.data }
      };
    case CUSTOM_FIELDS_TYPES.FAIL:
      return {
        ...state,
        loading: false,
        error: true
      };

    default:
      return state;
  }
};
